<template>
  <v-app id="inspire">
    <Loader ref="Loader"></Loader>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <v-content>
      <v-img style="position:fixed; width:100%; height:100%;" position="100% 100%" src="Attraction/body.jpg"
        gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"></v-img>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm6 md4 lg4 xl4>
            <v-card class="elevation-12" color="rgb(255, 255, 255, 0.6">
              <v-form @submit.prevent="Login">
                <v-card-text>
                  <v-layout align-center justify-center row mb-2>
                    <v-img width="100%" height="100%" src="Attraction/suburban.png">
                    </v-img>
                  </v-layout>
                  <v-text-field v-model="username" color="primary" prepend-icon="person" name="login" label="Login"
                    type="text"></v-text-field>
                  <!-- <v-text-field v-model="password" color="primary" id="password" prepend-icon="lock" name="password"
                    label="Password" type="password"></v-text-field> -->
                  <v-text-field prepend-icon="lock" label="Password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'"
                    v-model="password" name="password" color="primary" id="password">
                  </v-text-field>
                </v-card-text>
                <v-card-actions>
                  <!-- <v-btn color="primary" @click="forgotPassword">Forgot Password</v-btn> -->
                  <v-spacer></v-spacer>
                  <v-btn type="submit" color="primary">Login</v-btn>
                  <!-- <v-btn color="secondary" @click="$router.push('/register')">{{TranslateText("Register")}}</v-btn> -->
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer app dark inset fixed color="darkgray">
      <v-spacer></v-spacer>
      <div>Powered by DevInspire (Pty) Ltd. &copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>

<script>
  import JWT from "jsonwebtoken";
  export default {
    data: () => ({
      drawer: null,
      username: "",
      password: "",
      showPassword: false,
    }),
    mounted() {
      let self = this;

      localStorage.clear();
    },
    methods: {
      Login() {
        let self = this;
        self.$refs.Loader.show(true);
        self.$refs.Loader.setText("Logging in...");
        self
          .get(
            `Authentication/User/Login?username=${self.username}&password=${
            self.password
          }`,
            null,
            false
          )
          .then(r => {
            self.$store.commit('setUserSessionData', r.data);
            localStorage.setItem('accessToken', r.data.AccessToken);
            localStorage.setItem('refreshToken', r.data.RefreshToken);
            localStorage.setItem('UserLogin', r.data.UserLogin);
            
            if (r.data.Role != null) {
              localStorage.setItem('Role', r.data.Role.Name);
              localStorage.setItem('RoleID', r.data.Role.ID);
            }
            let tokenDecoded = JWT.decode(localStorage.accessToken);

            let userID = tokenDecoded.USER_ID;
            console.log("USER_ID", userID);
            localStorage.setItem("USER_ID", userID)
            self.$refs.Loader.hide();

            self.get(`CustomerUser/Single?customerUserID=${userID}`).then(r => {
              if(r.data.CustomerUser != null){
                console.log(r.data)
                localStorage.setItem("USER_ID", r.data.CustomerUser.CustomerID);
              }
            })

            if (r.data.UserLogin == true) {
              self.$router.push("/notifications/dashboard");
            } else {
              self.$router.push("/customerportal/feedback");
            }
          })
          .catch(error => {
            self.$refs.Loader.hide();
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });
      },
      forgotPassword() {
        let routeData = this.$router.resolve({
          path: "/forgot_password"
        });

        window.open(routeData.href, "_blank");
      }
    },

    props: {
      source: String
    }
  };
</script>